<template>
  <div class="post-webwidget-v2-playlist" :class="playlistClassList">
    <div class="post-webwidget-v2-playlist-row post-webwidget-v2-playlist-row--heading">
      <h4 class="post-webwidget-v2-playlist-heading-label">Playlist</h4>
    </div>
    <div v-if="isLoading || errorMessage" class="post-webwidget-v2-playlist-row">
      <template v-if="isLoading">
        Loading episodes...
      </template>
      <template v-if="errorMessage">
        {{ errorMessage }}
      </template>
    </div>
    <template v-else>
      <div v-if="episodeList.length === 0" class="post-webwidget-v2-playlist-row">
        No episodes exist.
      </div>
      <div v-else class="post-webwidget-v2-playlist-episode-list-container">
        <div 
          v-for="episode in episodeList" :key="episode.id"
          class="post-webwidget-v2-playlist-row post-webwidget-v2-playlist-episode-list-item"
          :class="getEpisodeRowClassList(episode.id)"
          @click="onEpisodeClick(episode.id)"
        >
          <div class="post-webwidget-v2-playlist-episode-list-item-contents">
            <div 
              v-if="isEpisodePlaying(episode.id)"
              @click.stop="onPauseButtonClick"
              class="post-webwidget-v2-playlist-episode-list-item-contents-pause-button"
            >
              <img :src="pauseButtonImageSrc" width="10" height="10">
            </div>
            <div 
              v-else
              @click.stop="onPlayButtonClick(episode.id)"
              class="post-webwidget-v2-playlist-episode-list-item-contents-play-button"
            >
              <img :src="playButtonImageSrc" width="10" height="10">
            </div>
            <div class="post-webwidget-v2-playlist-episode-list-item-contents-episode-name">
              {{ episode.name }}
            </div>
            <div class="post-webwidget-v2-playlist-episode-list-item-contents-episode-date">{{ formatDate(episode.timestamp_created) }}</div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'playlist',
  props: {
    darkTheme: Boolean,
    errorMessage: String,
    isLoading: Boolean,
    isActiveEpisodePaused: {
      type: Boolean,
      default: true,
    },
    episodeList: {
      required: true,
      type: Array,
    },
    activeEpisodeId: {
      required: false,
      type: Number,
      default: undefined,
    },
  },
  computed: {
    playlistClassList() {
      return {
        'post-webwidget-v2-playlist--dark-theme': this.darkTheme,
      };
    },
    pauseButtonImageSrc() {
      return require(this.darkTheme ? '../../static/icons/white/svg/pause.svg' : '../../static/icons/grey/svg/pause.svg');
    },
    playButtonImageSrc() {
      return require(this.darkTheme ? '../../static/icons/white/svg/play.svg' : '../../static/icons/grey/svg/play.svg');
    },
  },
  methods: {
    getEpisodeRowClassList(episodeId) {
      return {
        'post-webwidget-v2-playlist-episode-list-item--active': episodeId === this.activeEpisodeId,
      };
    },
    onPauseButtonClick() {
      this.$emit('episode-pause-button');
    },
    onPlayButtonClick(episodeId) {
      this.$emit('episode-play-button', episodeId);
    },

    isEpisodePlaying(episodeId) {
      return episodeId === this.activeEpisodeId && !this.isActiveEpisodePaused;
    },
    formatDate(date) {
      return date.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
      });
    },
    onEpisodeClick(episodeId) {
      this.$emit('episode-click', episodeId);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../assets/variables-v2';
.post-webwidget-v2-playlist {
  &-row {
    padding: 1em;
    text-size-adjust: 100%; // iOS text size fix
    
    &--heading {
      border-top: 1.5px solid $borderColor;
      // border-bottom: 3.5px double $borderColor; // <-- alternative border style to play with
      border-bottom: 1.5px solid $borderColor;
      margin-bottom: 0.5px;
      .post-webwidget-v2-playlist-heading-label {
        margin: 0;
        text-transform: uppercase;
      }
    }
  }

  &-episode-list-container {
    max-height: 165px; // Enough to hold 3.5 items
    overflow: auto;
  }

  &-episode-list-item {
    cursor: pointer;

    &:not(:first-child) {
      border-top: 1.25px solid $borderColor;
    }
    &:last-child {
      border-bottom-left-radius: $borderRadius;
      border-bottom-right-radius: $borderRadius;
    }

    &:hover {
      background: mix(white, $playlistEpisodeBackground, 1%);
    }

    &--active {
      background: $playlistEpisodeBackground;
      &:hover {
        background: $playlistEpisodeBackground;
      }
    }

    &-contents {
      display: inline-flex;
      width: 100%;

      &-play-button, &-pause-button {
        width: 10px;
        margin-right: 1em;
      }

      &-episode-name {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-right: 1em;
      }

      &-episode-date {
        flex-grow: 1;
        text-align: right;
        white-space: nowrap;
        color: $playlistEpisodeDateColor;
      }
    }
  }
}

/** Dark theme **/
.post-webwidget-v2-playlist--dark-theme {
  .post-webwidget-v2-playlist-row {
    &--heading {
      border-top-color: $darkThemeBorderColor;
      border-bottom-color: $darkThemeBorderColor;
    }
  }

  .post-webwidget-v2-playlist-episode-list-item { 
    &:not(:first-child) {
      border-color: $darkThemeBorderColor;
    }

    &:hover {
      background: mix(white, $darkThemePlaylistEpisodeBackground, 1%);
    }
  }

  .post-webwidget-v2-playlist-episode-list-item--active {
    background: $darkThemePlaylistEpisodeBackground;
    &:hover {
      background: $darkThemePlaylistEpisodeBackground;
    }
  }

  .post-webwidget-v2-playlist-episode-list-item-contents-episode-date {
    color: $darkThemePlaylistEpisodeDateColor;
  }
}
</style>



// WEBPACK FOOTER //
// Playlist.vue?26b9cca8